<!-- Sub header for report templates -->
<app-subheader-main></app-subheader-main>
<div class="base-content-wrapper">    
    <app-message-dialog class="page-message-dialog"></app-message-dialog>
    <div class="main-content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div> 
    
